import { ReactNode } from 'react';
import { Checkbox } from './Checkbox.js';
import { Button } from './Button.js';

export interface ListToolbarProps {
  allSelected: boolean;
  someSelected?: boolean;
  onSelectAll: (selected: boolean) => void;
  onExpandAll?: () => void;
  onCollapseAll?: () => void;
  expandLabel?: string;
  collapseLabel?: string;
  children?: ReactNode;
}

export function ListToolbar({
  allSelected,
  someSelected,
  onSelectAll,
  onExpandAll,
  onCollapseAll,
  expandLabel = 'Expand all',
  collapseLabel = 'Collapse all',
  children,
}: ListToolbarProps) {
  const hasActions = !!onExpandAll || !!onCollapseAll;
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        height: 'var(--evo-toolbar-height)',
        boxSizing: 'border-box',
        paddingLeft: 'var(--evo-list-pad-x)',
        paddingRight: 16,
        borderBottom: '1px solid var(--evo-stroke)',
        background: 'var(--evo-bg-2)',
        flexShrink: 0,
      }}
    >
      <Checkbox
        checked={allSelected}
        indeterminate={!!someSelected && !allSelected}
        onChange={onSelectAll}
      />
      {children}
      {hasActions && (
        <div style={{ marginLeft: 'auto', display: 'flex', gap: 4 }}>
          {onExpandAll && (
            <Button variant="outline" tone="muted" size="sm" onClick={onExpandAll}>
              {expandLabel}
            </Button>
          )}
          {onCollapseAll && (
            <Button variant="outline" tone="muted" size="sm" onClick={onCollapseAll}>
              {collapseLabel}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
